'use client'

import dynamic from 'next/dynamic'

import AppDock from '@/components/AppDock'

// Dynamically import the canvas component to avoid hydration issues
const InspirationCanvas = dynamic(
  () => import('./_components/InspirationCanvas'),
  {
    ssr: false,
  },
)

export default function InspirationPage() {
  return (
    <div className="relative h-screen w-full overflow-hidden">
      <h1 className="sr-only">Inspiration Canvas</h1>
      {/* Main Canvas Component */}
      <InspirationCanvas />

      {/* Reusable App Dock */}
      <AppDock />
    </div>
  )
}
